import route53 from './route53';

export default {
    namespaced: true,
    modules: {
        route53,
    }
}